import React from 'react'
import Banners from '../../Components/Banners/Banners'
import Products from '../../Components/Products/Products'
import './Demo.css'
import Footer from '../../Components/Footer/Footer'
import Cart from '../../Components/Cart/Cart'
import Developer from '../../Components/Developer/Developer'
import CatalogWarmup from '../../Components/CatalogWarmup/CatalogWarmup'
export default function Demo() {
    return (
        <section className='demo'>
            <CatalogWarmup />
            <Banners />
            <Products />
            <Footer />
            <Developer />
            <Cart />
        </section>
    )
}
